let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gKxLJ")).then(() => parcelRequire('b5zjM'));